// Libraries
import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  Text,
} from 'recharts';

// Enums
import { SingleSelectQuestionDataType } from 'engagementReport/enums/propTypes';

// Helpers
import { rtlLanguage } from 'common/utils/helpers';

// Components
import CustomTooltip from 'admin/engagement/reporting/components/CustomTooltip';

const tooltipAttributes = [
  { tooltipLabel: 'Percentage', payloadKey: 'percentage', percentage: true },
  { tooltipLabel: 'Count', payloadKey: 'count' },
];

const SingleSelectVerticalBarChart = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" aspect={16 / 9}>
      {/* eslint-disable react/no-array-index-key, react/prop-types */}
      <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
        <CartesianGrid vertical={false} stroke="#e8e8e8" strokeWidth={1} />
        <Tooltip
          content={<CustomTooltip attributes={tooltipAttributes} />}
          cursor={{ fill: 'rgba(100, 100, 100, 0.05)' }}
          isAnimationActive={false}
        />
        <Bar
          dataKey="percentage"
          name="Percentage"
          background={{ fill: '#d6d6d6' }}
          barSize={20}
          unit="%"
        >
          {data.map((entry, index) => (
            <Cell key={index} fill={entry.top ? '#5b7d12' : '#4a90e2'} />
          ))}
        </Bar>
        <XAxis
          type="category"
          dataKey="label"
          tickLine={false}
          tick={(props) => (
            <Text {...props} width={props.width / data.length - 10} fontSize={14}>
              {props.payload.value}
            </Text>
          )}
          stroke="#636363"
          strokeWidth={1}
          interval={0}
        />
        <YAxis
          type="number"
          domain={[0, 100]}
          ticks={[0, 25, 50, 75, 100]}
          tickLine={false}
          unit="%"
          interval={0}
          axisLine={false}
          orientation={rtlLanguage() ? 'right' : 'left'}
        />
      </BarChart>
      {/* eslint-enable react/no-array-index-key, react/prop-types */}
    </ResponsiveContainer>
  );
};

SingleSelectVerticalBarChart.propTypes = {
  data: SingleSelectQuestionDataType.isRequired,
};

export default SingleSelectVerticalBarChart;
